import React from "react";
// eslint-disable-next-line react/no-deprecated
import { render } from "react-dom";
import bugsnagReact from "@bugsnag/plugin-react";

import "./globals";
import "./style.css";
import App from "./App";

// Make React instance global so Bugsnag does not crash
window.React = React;

let BugSnagWrapper = props => props.children;

if (window.bugsnagClient) {
  window.bugsnagClient.use(bugsnagReact, React);
  if (window.bugsnagClient.getPlugin) {
    BugSnagWrapper = window.bugsnagClient.getPlugin("react");
  }
}

render(
  <BugSnagWrapper>
    <App />
  </BugSnagWrapper>,
  document.getElementById("app")
);
